module.exports = __webpack_public_path__ + "static/media/USA-CWRU.449e956f.jpg";